(function ($, d, ns) {
    ns.initResponsiveTables = function () {
        $('.js-table-wrapper table').each(function (index) {

            var table = $(this);
            var cols = $(this).find('th').length;
            var rows = $(this).find('tr').length;
            for (var i = 1; i <= rows; i++) {
                $(this).find("tr:nth-child(" + i + ")").find('td').each(function (cellIndex) {
                    titleIndex = cellIndex + 1;

                    $(this).attr('data-title', $(table).find('tr th:nth-child(' + titleIndex + ')').html()); 

                });
            };
        });
    }

    $(d).ready(function () {
        ns.initResponsiveTables();
    });


})(jQuery, document, Crafted.Utilities);

